import { createFileRoute } from '@tanstack/react-router';
import Sites from '../../../administration/src/components/Apps/AppDetails/Installation/Sites';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/installation/sites')({
  component: withModalOutlet(Sites),
});
